import { LocationPicker } from "./LocationPicker";
import { BrandGuard } from "./BrandGuard";

export const Brand = () => {
  return (
    <BrandGuard>
      <LocationPicker/>
    </BrandGuard>
  );
};
